var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-badge"},[_c(_vm.iconOutside,{tag:"component",staticStyle:{"opacity":"50%"}}),(_vm.title || _vm.iconInside)?_c('div',{class:_vm.cssClass ||
    `u-badge__container u-badge__type-${_vm.type}
    u-badge__size-${_vm.size}`},[_c(_vm.iconInside,{tag:"component"}),_c('p',[_vm._v(_vm._s(_vm.title))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }